import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom'; // ⭐ Added Routes
import { useTenant } from './Common/Contexts/TenantContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import WebsiteManager from './WebsiteManager';



// Admin Import

// Templates
const Template_1 = lazy(() => import('./Templates/Template_1'));
const Template_2 = lazy(() => import('./Templates/Template_2'));
const Template_3 = lazy(() => import('./Templates/Template_3'));
const Template_4 = lazy(() => import('./Templates/Template_4'));
const Template_5 = lazy(() => import('./Templates/Template_5'));
const templateMap = {
  Template_1,
  Template_2,
  Template_3,
  Template_4,
  Template_5,
};

function App() {
  const { tenantData, loading } = useTenant();

  if (loading) return (
     <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status"></div>
     </div>
  );

  const ref = tenantData?.templateReference;
  const ActiveTemplate = templateMap[ref];

  return (
    <>
      <Routes>
        {/* ⭐ ADMIN ROUTE: This is available on all domains */}
          <Route path="/admin/website-manager" element={<WebsiteManager />} />
       

        {/* ⭐ PUBLIC WEBSITE ROUTE */}
        <Route path="*" element={
          !ActiveTemplate ? (
            /* Website Not Configured Screen */
            <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
              <div className="text-center p-5 shadow-sm bg-white rounded-4" style={{ maxWidth: '400px' }}>
                <h1 className="display-4 text-muted mb-3">404</h1>
                <h5 className="fw-bold">Website Not Configured</h5>
                <p className="text-secondary small">This domain is not associated with an active template.</p>
                <hr /><small className="text-muted">© 2026 Smart Travel Platform</small>
              </div>
            </div>
          ) : (
            /* Dynamically Loaded Template */
            <Suspense fallback={<div className="text-center p-5">Loading Website...</div>}>
              <ActiveTemplate />
            </Suspense>
          )
        } />
      </Routes>

      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default App;